var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.creativeKidsNewUi
      ? _c(
          "div",
          [
            _c("CreativeKids", {
              attrs: {
                "tuo-client": _vm.tuoClient,
                "save-page": _vm.creativeKidsContactDetail
              }
            })
          ],
          1
        )
      : _vm.updatedDetails.length !== 0
      ? _c("div", [
          _vm.saveAll && !_vm.saveError
            ? _c(
                "div",
                [
                  _vm.saveSuccess === undefined
                    ? _c("UpdateDetailsSaveAll", {
                        attrs: {
                          "updated-details": _vm.updatedDetails,
                          "on-save-update": _vm.saveCustomerUpdate
                        }
                      })
                    : _vm._e(),
                  _vm.saveSuccess ? _c("SaveSusses") : _vm._e()
                ],
                1
              )
            : !_vm.saveError
            ? _c(
                "div",
                [
                  _vm.saveSuccess === undefined
                    ? _c("UpdateDetails", {
                        attrs: {
                          "updated-details": _vm.updatedDetails,
                          "on-save-update": _vm.saveCustomerUpdate
                        }
                      })
                    : _vm._e(),
                  _vm.saveSuccess
                    ? _c(
                        "div",
                        [
                          _c("Notice", {
                            attrs: {
                              id: "tuo-confirm-success-message",
                              header:
                                "Your information was saved successfully.",
                              message:
                                "View, update or add information in the 'Personal Details' section of your MyServiceNSW Account.",
                              "notice-type": "SUCCESS"
                            }
                          }),
                          _c(
                            "Button",
                            {
                              attrs: { secondary: "" },
                              on: { click: _vm.goToMyServiceNSW }
                            },
                            [_vm._v(" Go to MyServiceNSW Account ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.saveError
            ? _c(
                "div",
                [
                  _c("Notice", {
                    attrs: {
                      id: "tuo-confirm-failed-message",
                      header: "Sorry, something went wrong on our end.",
                      message:
                        "We're unable to save your information to your MyServiceNSW Account at this time.",
                      "secondary-message":
                        "You can still save your details in the 'Personal Details' section of your MyServiceNSW Account.",
                      "notice-type": "ERROR"
                    }
                  }),
                  _c(
                    "Button",
                    {
                      attrs: {
                        id: "tuo-goto-myservicensw-button",
                        secondary: ""
                      },
                      on: { click: _vm.goToMyServiceNSW }
                    },
                    [_vm._v(" Go to MyServiceNSW Account ")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }